import React from 'react';

import { eventsReportConfiguration } from '@totem/components/services/threats/eventsDashboard/report/configuration';
import EventsReportContainer from '@totem/components/services/threats/eventsDashboard/report/EventsReportContainer';
import EventsReportLayout, {
  EventsReportTitle,
} from '@totem/components/services/threats/eventsDashboard/report/EventsReportLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const EventsReportPage = () => (
  <ContentLayout>
    <InputContainer
      componentKey={'dashboard.events-v2'}
      componentLabel={'Services: Events (v2)'}
      filterConfig={eventsReportConfiguration}
      useUrlParams
      defaultSort={{ field: 'eventTime', direction: 'descend' }}
    >
      <EventsReportContainer>
        <IBCard isCovered title={<EventsReportTitle />}>
          <EventsReportLayout />
        </IBCard>
      </EventsReportContainer>
    </InputContainer>
  </ContentLayout>
);

export default EventsReportPage;
